import React from "react"
import ModalComponent from "./Modal"
import { Button, Spinner } from "react-bootstrap"

const SweetAlerts = ({
  showAlert,
  alertMessage,
  btnsuccessText,
  iconClassName,
  handleClose,
  handleAlert,
  loading,
  alertSubMessage
}) => {
  return (
    <ModalComponent
      show={showAlert}
      modalsize={"md"}
      animationFade={true}
      backdrop="static"
      className="alert_body py-5"
      children={
        <div className="alerts_wrapper">
          <i
            className={`icon_main mb-3 ${iconClassName || "delete_trash"}`}
          ></i>
          <h2 className="alert_title">
            {alertMessage || "Default Alert Title"}
          </h2>
          {alertSubMessage &&
            <p className="fs_14">{alertSubMessage}</p>
          }
          <div className="btns_alerts d-flex gap-3 justify-content-center">
            <Button
              variant="primary"
              onClick={() => {
                handleAlert()
                handleClose()
              }}
            >
              {btnsuccessText || loading ? (
                <Spinner size="sm" animation="border" variant="white" />
              ) : (
                "Yes"
              )}
            </Button>
            <Button variant="light" onClick={handleClose}>
              Cancel
            </Button>
          </div>
        </div>
      }
    />
  )
}

export default SweetAlerts
